var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "info-circle-Filled_1_",
    d: "M364,2555a15,15,0,1,0,15,15A15.024,15.024,0,0,0,364,2555Zm1.5,21a1.5,1.5,0,1,1-3,0v-6a1.5,1.5,0,1,1,3,0Zm-1.5-10.5a1.5,1.5,0,1,1,1.5-1.5A1.506,1.506,0,0,1,364,2565.5Z",
    transform: "translate(-349 -2555)",
    fill: "#e23744"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/informationIcon.8916cbb3c15c0da0f5318b31fe3b6839.svg";
export { ForwardRef as ReactComponent };